import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

import { CalendarFilter } from "~/components/FilterWrapper/components/CalendarFilter/CalendarFilter"
import { EmptyFilter } from "~/components/FilterWrapper/components/EmptyFilter/EmptyFilter"
import { NameFilter } from "~/components/FilterWrapper/components/NameFilter/NameFilter"
import { FilterPreloaderWrapper } from "~/components/FilterWrapper/components/PreloaderWrapper/PrealoderWrapper"
import { ShowMore } from "~/components/FilterWrapper/components/ShowMore/ShowMore"
import { FilterWrapper } from "~/components/FilterWrapper/FilterWrapper"

import { Cell, TopCell } from "../Cells/Cells"
import styles from "./index.module.css"

export const Filter: React.FC = () => {
  const { t } = useTranslation()

  const [showSecretLinks, setShowSecretLinks] = useState(false)
  const secret =
    "s6c7cbzxq9zkgqx56ox305cgdl4go9w3fwl3hmm5tg912uyp94mebl56da6htrmdgr396bb8c4pxhrcdqkv2b05wy0d89a1duljnlo4uguhd7gk75h5vnvf46xw38k0s"

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)

    if (params.get("secret") === secret) {
      setShowSecretLinks(true)
    }
  }, [])

  return (
    <FilterWrapper url={"/documents/elements"}>
      {({ items }) => (
        <>
          <div className={styles.Filters}>
            <div className={styles.Grid}>
              <NameFilter placeholder={t("docs.filterPlaceholder")} />
              <CalendarFilter />
            </div>
          </div>
          {items.length === 0 ? (
            <EmptyFilter />
          ) : (
            <>
              <TopCell />

              <FilterPreloaderWrapper className={styles.Items}>
                {items.map(({ id, name, date, file, secret }) => {
                  if (file) {
                    if (!showSecretLinks && secret) return

                    return <Cell key={id} date={date} file={file} name={name} />
                  }
                })}
              </FilterPreloaderWrapper>

              <ShowMore />
            </>
          )}
        </>
      )}
    </FilterWrapper>
  )
}
